module.exports = __webpack_public_path__ + "media/images/ibjjf/bg-check-1-5989999a6bfe1eb5db462470975d28a5.svg";